export default __webpack_public_path__ + "static/media/FTE-breakdown.f7867a7f.svg";